import Component from '@glimmer/component';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import BudgetReconciliationBillAlert from 'tio-employee/components/budget-reconciliation-bill-alert';
import AlertBanner from 'tio-ui/components/alert-banner';
import { t } from 'ember-intl';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import pageTitle from 'ember-page-title/helpers/page-title';

export default class PslfDashboardLayout extends Component {
  @service declare router: RouterService;

  // The 0726 pilot shows its own present-tense bill alert (mirroring
  // strategy-finder-0726) instead of the shared future-tense one. This applies
  // to the forgiveness-estimator-0726 route subtree AND to the dashboard in
  // ?estimator0726=true mode.
  get show0726BillAlert() {
    const routeName = this.router.currentRouteName ?? '';
    if (routeName.startsWith('authenticated.pslf.dashboard.forgiveness-estimator-0726')) {
      return true;
    }
    return this.router.currentRoute?.queryParams?.['estimator0726'] === 'true';
  }

  <template>
    {{pageTitle "PSLF" prepend=false}}
    <VStack>
      <PageHeader @title={{t "pslf.default_full"}}>
        <:below>
          {{#if this.show0726BillAlert}}
            <AlertBanner @intent="info" data-test-fe-0726-bill-alert>
              <h2 class="text-base">
                <strong>{{t "forgiveness_estimator_0726.bill_alert.header"}}</strong>
              </h2>
              <p>{{t "forgiveness_estimator_0726.bill_alert.body"}}</p>
            </AlertBanner>
          {{else}}
            <BudgetReconciliationBillAlert />
          {{/if}}
        </:below>
      </PageHeader>
      {{outlet}}
    </VStack>
  </template>
}
